import { render, staticRenderFns } from "./CampaignStatus.vue?vue&type=template&id=0fc2280d"
import script from "./CampaignStatus.vue?vue&type=script&lang=js"
export * from "./CampaignStatus.vue?vue&type=script&lang=js"
import style0 from "./CampaignStatus.vue?vue&type=style&index=0&id=0fc2280d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports